export default function Disclaimer() {
  return (
    <div className="disclaimer-bar" role="note">
      <span>
        Visible colors are <strong>approximated</strong> from infrared data and may differ from
        the original scene.
      </span>
    </div>
  );
}
